import { render } from "./BasePatientAccessInfoOffcanvas.vue?vue&type=template&id=1e1e5bf4&scoped=true"
import script from "./BasePatientAccessInfoOffcanvas.vue?vue&type=script&lang=js"
export * from "./BasePatientAccessInfoOffcanvas.vue?vue&type=script&lang=js"

import "./BasePatientAccessInfoOffcanvas.vue?vue&type=style&index=0&id=1e1e5bf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1e5bf4"]])

export default __exports__